import FootballStatsCategory from "../../../stats/football-stats-category";
import FootballState from "../../../state/football-state";
import StatsRule from "../../../../common/stats-rule";

export default class FumbleSnapStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.FumbledSnapRecovered &&
            !play
                .getFragmentsBetween(fragment, FootballState.Finalize)
                ?.some((f) =>
                    [
                        FootballState.Rush,
                        FootballState.Punt,
                        FootballState.FieldGoal,
                        FootballState.Pass
                    ].some((s) => s === f.associatedState)
                ) &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { recoveredBy, recoveredAt } = fragment;

        const yards_gained =
            (recoveredAt - gameContext.fieldPosition) *
            gameContext.getFieldDirectionMultiplier();

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: recoveredBy.teamId,
            playerId: recoveredBy.id,
            driveId: gameContext.currentDriveId,
            fragmentId: fragment.id,
            category: FootballStatsCategory.RUSH,
            values: {
                attempted: 1,
                completed: 1,
                yards: yards_gained
            }
        });
    }
}
